import axios from "axios";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import LoadingScreen from "../../components/LoadingScreen";

class RegistBrief extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullname: "",
      institusi: "",
      email: "",
      phone: "",
      password: "",
      showpass: false,
      disabled: false,
      isReady: false,
      errors: [],
      alert: null,
      message: "",
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleShowPass = this.handleShowPass.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.hasErrorFor = this.hasErrorFor.bind(this);
    this.renderErrorFor = this.renderErrorFor.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/customer/whois`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((res) => {
        var msg = res.data.success;
        if (msg === true) {
          this.props.history.push("/");
        } else {
          this.setState({
            isReady: true,
          });
        }
      });
  }

  handleFieldChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleShowPass() {
    if (this.state.showpass) {
      this.setState({
        showpass: false,
      });
    } else {
      this.setState({
        showpass: true,
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({
      disabled: true,
      errors: [],
    });

    const formData = new FormData();

    formData.append("fullname", this.state.fullname);
    formData.append("institusi", this.state.institusi);
    formData.append("email", this.state.email);
    formData.append("phone", this.state.phone);
    formData.append("password", this.state.password);

    axios
      .post(`${window.localhost}/customer/register`, formData)
      .then((response) => {
        // redirect to the homepage
        var msg = response.data.success;
        if (msg === true) {
          this.setState({
            message: response.data.message,
            errors: [],
          });
          return this.goToHome();
        }
      })
      .catch((error) => {
        console.log(error.response.data);
        this.setState({
          errors: error.response.data,
          disabled: false,
        });
      });
  }

  goToHome() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Success!"
        onConfirm={() => this.onSuccess()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
      >
        {this.state.message}
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  onSuccess() {
    this.props.history.push("/login");
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  hasErrorFor = (field) => {
    return !!this.state.errors[field];
  };

  renderErrorFor(field) {
    if (this.hasErrorFor(field)) {
      return (
        <span className="invalid-feedback">
          <strong>{this.state.errors[field][0]}</strong>
        </span>
      );
    }
  }

  render() {
    if (!this.state.isReady) {
      return <LoadingScreen />;
    } else {
      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>Registration Page - Creatifa Logo Brief</title>
            <meta
              name="description"
              content="Brief ini untuk membantu kami dalam membuat desain logo Anda. Mohon luangkan waktu untuk mengisi dengan jawaban se-objektif mungkin. Semakin Anda menuliskan gambaran usaha Anda dengan jelas, semakin kami dapat memahami desain logo seperti apa yang Anda butuhkan"
            />
          </Helmet>
          <div className="container wrapper">
            <div className="row">
              <div className="col-md-6 col-12 mx-auto">
                <div className="text-center">
                  <img
                    src={`/img/creatifa-logo-only.png`}
                    className="logo-header mb-3"
                    alt="logo creatifa"
                  />
                  <h1 className="font-poppins fw-bold mb-4">
                    <span className="cf-header px-2">Creatifa Register</span>
                  </h1>
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="fullname" className="form-label">
                      Nama Lengkap
                    </label>
                    <input
                      name="fullname"
                      type="text"
                      id="fullname"
                      aria-describedby="fullname"
                      className={`form-control form-cream ${
                        this.hasErrorFor("fullname") ? "is-invalid" : ""
                      }`}
                      onChange={this.handleFieldChange}
                      value={this.state.fullname}
                      disabled={this.state.disabled}
                    />
                    {this.renderErrorFor("fullname")}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="institusi" className="form-label">
                      Institusi / Perusahaan
                    </label>
                    <input
                      name="institusi"
                      type="text"
                      id="institusi"
                      aria-describedby="institusi"
                      className={`form-control form-cream ${
                        this.hasErrorFor("institusi") ? "is-invalid" : ""
                      }`}
                      onChange={this.handleFieldChange}
                      value={this.state.institusi}
                      disabled={this.state.disabled}
                    />
                    {this.renderErrorFor("institusi")}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email address
                    </label>
                    <input
                      name="email"
                      type="email"
                      id="email"
                      aria-describedby="email"
                      className={`form-control form-cream ${
                        this.hasErrorFor("email") ? "is-invalid" : ""
                      }`}
                      onChange={this.handleFieldChange}
                      value={this.state.email}
                      disabled={this.state.disabled}
                    />
                    {this.renderErrorFor("email")}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      Nomor Whatsapp
                    </label>
                    <input
                      name="phone"
                      type="text"
                      id="phone"
                      aria-describedby="phone"
                      className={`form-control form-cream ${
                        this.hasErrorFor("phone") ? "is-invalid" : ""
                      }`}
                      onChange={this.handleFieldChange}
                      value={this.state.phone}
                      disabled={this.state.disabled}
                    />
                    {this.renderErrorFor("phone")}
                  </div>

                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <div className="input-group mb-3">
                    <input
                      name="password"
                      type={this.state.showpass ? `text` : `password`}
                      className={`form-control form-cream ${
                        this.hasErrorFor("password") ? "is-invalid" : ""
                      }`}
                      id="password"
                      onChange={this.handleFieldChange}
                      value={this.state.password}
                      disabled={this.state.disabled}
                    />
                    <button
                      className="btn btn-yellow"
                      type="button"
                      id="button-addon2"
                      onClick={this.handleShowPass}
                    >
                      {this.state.showpass ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                    {this.renderErrorFor("password")}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-yellow rounded-4 px-4"
                    disabled={this.state.disabled}
                  >
                    <span
                      className={`spinner-border spinner-border-sm ${
                        this.state.disabled ? " " : "d-none"
                      }`}
                      role="status"
                      aria-hidden="true"
                    ></span>{" "}
                    Daftar
                  </button>
                </form>
                <hr />
                <div className="mt-3">
                  <p className="float-end font-poppins">
                    Sudah punya akun?{" "}
                    <Link
                      className="text-danger text-decoration-none"
                      to={`/login`}
                    >
                      Login disini
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {this.state.alert}
        </div>
      );
    }
  }
}

export default RegistBrief;
